<template lang="html">
  <DashboardTemplate>
    <div v-if="isLoading"><Loader /></div>
    <div class="col pt-3 fade-in">
      <div class="row p-3">
        <div class="col-md-12">
          <div class="row">
            <div class="col">
              <h1><i class="bi bi-braces-asterisk"></i> Story Type</h1>
            </div>
            <div class="col-12 bg-white mb-3 pt-3 mt-2 rounded-5 shadow-sm">
              <div class="row justify-content-end">
                <div class="col-auto">
                  <label for="inputPassword2" class="visually-hidden">Search</label>
                  <input
                    type="text"
                    class="form-control rounded-5"
                    placeholder="Search"
                    v-model="searchStoryType"
                    v-on:keyup.enter="searchClick()"
                  />
                </div>
                <div class="col-auto tooltip-wrap">
                  <button
                    type="submit"
                    class="btn btn-outline-primary mb-3 rounded-5"
                    @click="searchClick()"
                  >
                    <i class="bi bi-search"></i>
                    <span class="tooltip">Search Here</span>

                  </button>
                </div>
                <div class="col-auto tooltip-wrap">
                  <a
                    @click="addStoryType()"
                    class="btn btn-outline-success me-3 rounded-5"
                    ><i class="bi bi-database-add"></i>
                    <span class="tooltip">Add New</span>

                     </a
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="successMsg"
            class="card text-success text-center border-success rounded-5 mb-3"
          >
            <div class="card-body">{{ successMsg }}</div>
          </div>
          <ErrorDisplay :error="errorMsg" message="Unable to update type"/>
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="card-text">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th> Type</th>
                        <th> Slug</th>
                        <!-- <th>Edit</th> -->
                        <!-- <th>Delete</th> -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="allTypeLists?.total === 0">
                        <td scope="col" colspan="9" class="text-center text-primary pt-3 pb-3">
                          Not Found
                        </td>
                      </tr>
                      <tr class="text-center" v-else v-for="(type, index) in allTypeLists.items" :key="index">
                        <td>{{ type.title }}</td>
                        <td>{{ type.slug }}</td>
                        <!-- <td class="text-center">
                          <button
                            class="btn btn-outline-primary bi bi-pencil-square rounded-5"
                            data-bs-toggle="modal"
                            data-bs-target="#storyTypeEditModal"
                            @click="typeById(type.id)"
                          ></button>
                        </td> -->
                        <!-- <td class="text-center">
                          <button
                            class="btn btn-outline-danger bi bi-trash rounded-5"
                            data-bs-toggle="modal"
                            data-bs-target="#storyTypeDeleteModal"
                            @click="deletePopUp(type.id)"
                          ></button>
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center mt-4">
            <VuejsPaginateNext
              v-model="page"
              :page-count="pageCount"
              :click-handler="pageClick"
              :margin-pages="2"
              :page-range="3"
              :container-class="'pagination'"
              :page-class="'page-item'"
              :page-link-class="'page-link'"
              :prev-class="'prev-item'"
              :prev-link-class="'page-link prev-link-item'"
              :next-class="'next-item'"
              :next-link-class="'page-link next-link-item'"
              :break-view-class="'break-view'"
              :break-view-link-class="'break-view-link'"
            ></VuejsPaginateNext>
          </div>
        </div>
      </div>
    </div>
  </DashboardTemplate>

  <!-- add Modal -->
  <div
    class="modal fade"
    id="storyTypeAddModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="storyTypeAddModalLabel"
    aria-hidden="true"
    :class="{ showModal: modalShow , show: modalShow }"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="storyTypeAddModalLabel">Create New Type</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModal()"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="isLoading"><Loader /></div>
          <div class="container g-3">
            <div class="row">
              <div class="col-md-6">
                <label for="" class="form-label">Title</label> <input type="text" class="form-control" v-model="typesLists.title" />
                <span class="text-danger" v-if="v$.title.$error">
                      {{ v$.title.$errors[0].$message }}*
                    </span>
              </div>
              <div class="col-md-6">
                <label for="" class="form-label">Slug </label> <input type="text" class="form-control" v-model="typesLists.slug" />
                <span class="text-danger" v-if="v$.slug.$error">
                      {{ v$.slug.$errors[0].$message }}*
                    </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal()" data-bs-dismiss="modal">Cancel</button>
          <button
            @click="uploadType()"
            type="button"
            data-bs-dismiss="modal"
            class="btn btn-primary"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- edit Modal -->
  <div
    class="modal fade"
    id="storyTypeEditModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="storyTypeEditModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="storyTypeEditModalLabel">{{ typeDetails.title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="isLoading"><Loader /></div>
          <div class="container">
            <div class="row">
              <div class="col-md-6">
                <label for="" class="form-label">Title</label>
                <input type="text" class="form-control" v-model="editTypesLists.title" />
              </div>
              <div class="col-md-6">
                <label for="" class="form-label">Slug </label>
                <input type="text" class="form-control" v-model="editTypesLists.slug" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button
            @click="editUploadType()"
            type="button"
            data-bs-dismiss="modal"
            class="btn btn-primary"
          >
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- delete Modal -->
  <div
    class="modal fade"
    id="storyTypeDeleteModal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="storyTypeDeleteModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="storyTypeDeleteModalLabel">Are You Sure ?</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">Are you sure you want to delete? This action cannot be undone or reversed</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button
            type="button"
            data-bs-dismiss="modal"
            class="btn btn-primary"
            @click="typeDelete()"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import { useStore } from 'vuex';

import {
  ref, computed, onMounted, reactive,
} from 'vue';
import {
  required, email, helpers, between,
} from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';

import Loader from '@/components/commons/Loader.vue';
import DashboardTemplate from '@/components/templates/DashboardTemplate.vue';
import VuejsPaginateNext from '@/components/partials/Paginate.vue';
import TypesService from '@/services/TypesService';
import ErrorDisplay from '@/components/partials/ErrorDisplay.vue';

const typesService = new TypesService();

export default {
  name: 'About',
  props: [],
  components: {
    Loader,
    DashboardTemplate,
    VuejsPaginateNext,
    ErrorDisplay,
  },
  setup(props) {
    const store = useStore();
    const isLoading = ref(false);
    const searchStoryType = ref('');
    const typeId = ref('');
    const modalShow = ref(false);
    const currentOffset = ref(0);
    const perPageStory = ref(10);
    const pageCount = ref(0);
    const page = ref(1);
    const typesLists = reactive({
      title: '',
      slug: '',
    });
    const successMsg = ref('');
    const errorMsg = ref('');
    const editTypesLists = reactive({
      title: '',
      slug: '',
    });

    const rules = {
      title: { required: helpers.withMessage('Please enter title', required) },
      slug: { required: helpers.withMessage('Please enter a slug', required) },
    };

    const v$ = useVuelidate(rules, typesLists);

    isLoading.value = true;

    const SearchData = {
      searchStoryType,
      currentOffset,
      perPageStory,
    };

    store.dispatch('fetchAllStoryType', SearchData).then((response) => {
      pageCount.value = Math.ceil(response.data.total / perPageStory.value);
      isLoading.value = false;
    });

    const allTypeLists = computed(() => store.getters.getAllStoryType);

    const typeDetails = computed(() => store.getters.getStoryTypeDetails);

    const uploadType = async () => {
      const result = await v$.value.$validate();
      if (result) {
        isLoading.value = true;
        const Data = {
          title: typesLists.title.trim(),
          slug: typesLists.slug.trim(),
        };
        typesService.storyTypeUpload(Data).then(() => {
          typesLists.title = '';
          typesLists.slug = '';
          v$.value.$reset();
          modalShow.value = false;
          store.dispatch('fetchAllStoryType', SearchData).then((response) => {
            pageCount.value = Math.ceil(response.data.total / perPageStory.value);
            isLoading.value = false;
            successMsg.value = ' Story Type Has Been Added Successfully';
            setTimeout(() => {
              successMsg.value = '';
            }, 3000);
          });
        })
          .catch((error) => {
            modalShow.value = false;
            isLoading.value = false;
            errorMsg.value = error?.data;
            setTimeout(() => {
              errorMsg.value = '';
            }, 3000);
          });
      }
    };

    const addStoryType = () => {
      modalShow.value = true;
    };

    const closeModal = () => {
      modalShow.value = false;
      typesLists.title = '';
      typesLists.slug = '';
    };

    const pageClick = (pageNum) => {
      isLoading.value = true;

      currentOffset.value = perPageStory.value * (pageNum - 1);

      const Data = {
        searchStoryType,
        currentOffset,
        perPageStory,
      };

      store.dispatch('fetchAllStoryType', Data).then((response) => {
        pageCount.value = Math.ceil(response.data.total / perPageStory.value);

        isLoading.value = false;
      });
    };

    const typeById = (id) => {
      typeId.value = id;
      isLoading.value = true;
      store.dispatch('fetchStoryTypeDetails', id).then((res) => {
        editTypesLists.title = res.data.title;
        editTypesLists.slug = res.data.slug;
        isLoading.value = false;
      });
    };
    const editUploadType = () => {
      isLoading.value = true;
      const Data = {
        title: editTypesLists.title.trim(),
        slug: editTypesLists.slug.trim(),
      };
      typesService.storyTypeUpdate(typeId.value, Data).then(() => {
        store.dispatch('fetchAllStoryType', SearchData).then((response) => {
          pageCount.value = Math.ceil(response.data.total / perPageStory.value);
          isLoading.value = false;
        });
      });
    };

    const deletePopUp = (id) => {
      typeId.value = id;
    };

    const typeDelete = () => {
      isLoading.value = true;

      typesService.storyTypeDelete(typeId.value).then((deleted) => {
        store.dispatch('fetchAllStoryType', SearchData).then((response) => {
          successMsg.value = deleted?.data?.message;
          setTimeout(() => {
            successMsg.value = '';
          }, 3000);
          pageCount.value = Math.ceil(response.data.total / perPageStory.value);
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
          isLoading.value = false;
        });
      });
    };

    const searchClick = () => {
      currentOffset.value = 0;
      const search = {
        searchStoryType,
        currentOffset,
        perPageStory,
      };
      isLoading.value = true;
      store.dispatch('fetchAllStoryType', search).then((response) => {
        pageCount.value = Math.ceil(response.data.total / perPageStory.value);
        isLoading.value = false;
      });
    };

    return {
      isLoading,
      allTypeLists,
      typesLists,
      uploadType,
      typeId,
      typeById,
      editTypesLists,
      editUploadType,
      deletePopUp,
      typeDelete,
      typeDetails,
      searchStoryType,
      searchClick,
      v$,
      modalShow,
      addStoryType,
      closeModal,
      successMsg,
      errorMsg,
      pageClick,
      currentOffset,
      perPageStory,
      pageCount,
      page,
    };
  },
};
</script>
